export default __webpack_public_path__ + "static/01-04-reading-audio-narration-3f67590e29ec59eaf010d5d697c10274.mp4";